
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop7=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In the scenario where you have a background in mechanical engineering and aspire to pursue a master's in Computer Science and Engineering (CSE), your Statement of Purpose (SOP) should focus on your motivation, the relevance of your mechanical engineering background, and your commitment to the field of computer science.
                </p>


                 <p> <strong>Why this Course - Key Emphasis Section</strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of:</strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                 
                  </p>
                  This section is an opportunity to showcase your academic and, if applicable, professional journey. Detail your academic achievements, focusing on relevant courses or projects that have prepared you for the desired program. If you have work experience, highlight how it has contributed to your skills and knowledge. In the case of extracurricular activities, emphasize those that demonstrate skills applicable to the academic and professional world.
              
              <p  style={{marginTop: '8px',}}><strong>Mistakes that need to be taken care of:  </strong></p>
               <p><strong>Irrelevant Details: </strong>
                </p>
                <p>While providing your background, stay focused on elements that directly contribute to your suitability for the program. Avoid unnecessary details.</p>
                <h6> <strong>Overemphasis on Grades: </strong></h6>
                <p> While academic achievements are important, balance the discussion with other aspects of your background to present a holistic picture.</p>

                <p><strong>Why this Course - Key Emphasis Section </strong></p>

                <p><strong>What to Include:</strong></p>

          <p>Clearly express your motivation for transitioning from mechanical engineering to CSE. Discuss what specific experiences, challenges, or insights have driven your interest in computer science.</p>
          <p>  <strong>Relevance of Mechanical Engineering Background: </strong></p>
          <p>Highlight aspects of your mechanical engineering background that are relevant to CSE. This could include problem-solving skills, analytical thinking, project management, or any exposure to programming or technology integration.</p>
          <p><strong>Passion for Computer Science: </strong></p>
          <p>Communicate your genuine passion for computer science. Discuss specific experiences, projects, or challenges that have fueled your interest and motivated your decision to pursue a master's in CSE.</p>
          <p><strong>Transferable Skills: </strong></p>  
          <p>Emphasize transferable skills from your mechanical engineering background that will be beneficial in CSE. This could include skills in mathematics, logical reasoning, and an understanding of systems and processes.</p>
          <p><strong>Alignment with Career Goals: </strong></p>
          <p>Clearly state how the master's program in CSE aligns with your career goals. Discuss specific aspects of the program, such as courses, specializations, or research opportunities, that will help you achieve your objectives in the tech industry.</p>

          <p><strong>How to Pen It:  </strong></p>
          <p>Begin by expressing your motivation for transitioning from mechanical engineering to CSE. Clearly articulate the specific experiences or insights that have sparked your interest in computer science.</p>
          <p>Showcase the relevance of your mechanical engineering background to CSE. Discuss skills, projects, or coursework that demonstrate your analytical thinking and problem-solving abilities.</p>
          <p>Emphasize transferable skills from your mechanical engineering background that make you well-suited for the challenges and opportunities in CSE. Discuss how these skills will contribute to your success in the master's program.</p>
          <p>Communicate your passion for computer science, drawing on specific experiences or challenges that have motivated your decision to pursue advanced studies in the field.</p>
          <p>Conclude by summarizing how your unique combination of mechanical engineering background, passion for computer science, and transferable skills make you a strong candidate for the master's program at [University]. Express your eagerness to contribute to the program and make a meaningful impact in the tech industry.  </p>
          <p><strong>Example:</strong></p>
          <p>My academic journey in mechanical engineering has instilled in me a profound appreciation for problem-solving, analytical thinking, and the intricate interplay of systems. However, my experiences have led me to a pivotal realization—the transformative potential of computer science. The dynamic nature of this field, coupled with its power to address complex challenges, has fueled my passion for computer science. My background in mechanical engineering equips me 
            with a solid foundation in logical reasoning, mathematical analysis, and project management—skills that are inherently transferable to the world of computer science. As I envision the future, I see myself at the intersection of innovation and technology, contributing to advancements that shape our world. The Master's 
            program in Computer Science and Engineering at [University] stands out as the ideal platform to actualize this vision. The program's emphasis on [specific aspects of CSE] aligns seamlessly with my aspirations. I am eager to immerse myself in the vibrant academic environment at [University], where I hope to not only expand my knowledge but also make meaningful contributions to the dynamic field of computer science.</p>
         

               
               
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class="  martop" role="alert">
  
        <p>
          <strong>Career Goals </strong>
        </p>
         <p>In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.</p>


<p><strong>Mistakes that need to be taken care of:</strong></p>
{/* <p><strong>Vagueness: </strong></p> */}
<p><strong>Vagueness: </strong> Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
<p><strong>Contradictions: </strong>  Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>

        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals : </strong>
                  </p>
                  <li>
                  Explanation: In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.
                  </li>
                <p><strong>Mistakes that need to be taken care of:</strong></p>
                <strong>Vagueness:</strong>
                <p>Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
                <p><strong>Contradictions: </strong>Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>
        </>,
      },
      {
        title: 'Second',
        content: <>
      <p   style={{marginTop: '10px',}}><strong>Why this University:</strong> This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.</p>
      <p><strong>Mistakes that need to be taken care of:</strong></p>
      <p><strong>Generic Praise: </strong>Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
      <p><strong>Lack of Personalization:</strong>Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>
        Conclusion: Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.
      
      <p><strong>  Mistakes that need to be taken care of:</strong></p>
      {/* <br></br> */}
        <strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.
        <br></br><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.
      
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop7;
